import { Play, Pause, ChevronDown } from 'lucide-react';
import type { IAudioTimelineProps } from '@/@types/sceneEditorV2';

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

function AudioTimeline({
  totalDuration,
  currentTime,
  isPlaying,
  onPlayPause,
  onSeek,
}: IAudioTimelineProps) {
  const progressPercent =
    totalDuration > 0 ? (currentTime / totalDuration) * 100 : 0;

  return (
    <div className="flex items-center gap-3 px-4 py-2">
      {/* Play/Pause button */}
      <button
        onClick={onPlayPause}
        className="flex h-8 w-8 items-center justify-center rounded-full border border-border"
      >
        {isPlaying ? <Pause size={14} /> : <Play size={14} />}
      </button>

      {/* Time display */}
      <span className="text-sm text-foreground-muted tabular-nums">
        {formatTime(currentTime)} / {formatTime(totalDuration)}
      </span>

      {/* Progress bar */}
      <div className="flex-1">
        <div className="relative h-1 rounded-full bg-border">
          <div
            className="absolute left-0 top-0 h-full rounded-full bg-primary"
            style={{ width: `${progressPercent}%` }}
          />
          <input
            type="range"
            min={0}
            max={totalDuration}
            value={currentTime}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onSeek(Number(e.target.value))
            }
            className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          />
        </div>
      </div>

      {/* Duration dropdown (chevron) */}
      <ChevronDown size={14} className="text-foreground-muted" />
    </div>
  );
}

export { AudioTimeline };
